import { LoadingButton } from '@mui/lab';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useFormik } from 'formik';
import { useMemo, useState } from 'react';
import server from '../../../global/server';
import { useFetch } from '../../../hooks/useFetch';
import useHandleErrors from '../../../hooks/useHandleErrors';
import { useSnackbar } from 'notistack';

export default () => {
    const [viewDialog, setViewDialog] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { data, mutate, error, isLoading } = useFetch('/backoffice/topics');
    useHandleErrors(error);

    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    const { handleChange, handleSubmit, handleReset, setValues, values, errors, isSubmitting } = useFormik({
        initialValues: { name: '', status: '' },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                if (values.id) {
                    await server.put(`/backoffice/topics/${values.id}`, values);
                    enqueueSnackbar('Tópico alterado', { variant: 'success' });
                } else {
                    await server.post('/backoffice/topics', values);
                    enqueueSnackbar('Tópico adicionado', { variant: 'success' });
                }
                handleReset();
                setSubmitting(false);
                await mutate();
                setViewDialog(false);
            } catch (error) {
                setSubmitting(false);
                setErrs(error);
            }
        },
    });

    const columns = useMemo(() => [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'name', headerName: 'Topico', flex: 1 },
        { field: 'status', headerName: 'Status', width: 120 },
        {
            field: 'actions',
            headerName: '',
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: ({ row }) => (
                <Button
                    variant="text"
                    onClick={() => {
                        setValues(row, false);
                        setViewDialog(true);
                    }}
                    size="small"
                    sx={{
                        textTransform: 'none',
                        color: '#006a61',
                        fontWeight: 500,
                        fontSize: '0.8rem',
                    }}
                >
                    Alterar
                </Button>
            ),
        },
    ]);

    return (
        <>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => { handleReset(); setViewDialog(true); }}
                    sx={{
                        bgcolor: '#006a61',
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&:hover': { bgcolor: '#005a52' },
                    }}
                >
                    Adicionar tópico
                </Button>
            </Stack>

            <Box sx={{ height: 400 }}>
                <DataGrid
                    loading={isLoading}
                    rows={data || []}
                    columns={columns}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    sx={{
                        border: 'none',
                        '& .MuiDataGrid-columnHeaders': {
                            bgcolor: '#f5f5f5',
                            borderBottom: '1px solid #e8e8e8',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            color: '#555',
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f5f5f5',
                        },
                        '& .MuiDataGrid-row:hover': {
                            bgcolor: '#f9fffe',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            display: 'none',
                        },
                    }}
                />
            </Box>

            <Dialog
                open={viewDialog}
                onClose={() => { handleReset(); setViewDialog(false); }}
                fullWidth
                maxWidth="xs"
                PaperProps={{ sx: { borderRadius: '16px' } }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {values.id ? 'Editando tópico' : 'Novo tópico'}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        required
                        fullWidth
                        size="small"
                        name="name"
                        label="Nome do tópico"
                        value={values.name}
                        onChange={handleChange}
                        helperText={errors.name}
                        error={Boolean(errors.name)}
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <Button
                        onClick={() => { handleReset(); setViewDialog(false); }}
                        variant="outlined"
                        sx={{ textTransform: 'none', borderColor: '#ccc', color: '#666', borderRadius: '8px' }}
                    >
                        Cancelar
                    </Button>
                    <LoadingButton
                        loading={isSubmitting}
                        onClick={handleSubmit}
                        variant="contained"
                        sx={{
                            bgcolor: '#006a61',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: '8px',
                            '&:hover': { bgcolor: '#005a52' },
                        }}
                    >
                        Salvar
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};
